import { ModelType } from '@livv/models';
import { getLawLink } from '@livv/utils/helpers';
import { Box, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { ArrowLink } from '@components/Links';
import useAmplitude from '@utils/hooks/useAmplitude';
import { TrackingEventName } from '@utils/types/amplitude/events';

const labelSx: SxProps = {
    fontWeight: 'medium',
    lineHeight: 1.5,
    minHeight: 3,
    mr: 1,
    whiteSpace: 'nowrap',
};

export interface InfoItemProps {
    label: string;
    lightFont?: boolean;
    links?: string[];
    value?: string | string[];
}

const InfoItem: FC<InfoItemProps> = ({ label, lightFont, links, value }) => {
    const { track } = useAmplitude();

    const handleClick = (lawId: string) => {
        track({
            name: TrackingEventName.SIDE_EXTRA_CONTENT_CLICKED,
            params: {
                target_document_id: lawId,
                target_document_type: ModelType.LAW_TEXT,
            },
        });
    };

    if (!(value?.length || links?.length)) return null;

    return (
        <Box display="flex" mb={1} mt={1}>
            {Boolean(label) && (
                <Typography
                    sx={[labelSx, { color: lightFont ? 'text.disabled' : 'text.secondary' }]}
                >
                    {label}&nbsp;:
                </Typography>
            )}
            {value && (
                <Typography sx={{ color: lightFont ? 'text.secondary' : 'text.primary' }}>
                    {Array.isArray(value) ? value.join(', ') : value}
                </Typography>
            )}
            {links && (
                <Box display="flex" flexDirection="column">
                    {links.map((link) => (
                        <ArrowLink
                            key={link}
                            href={getLawLink(link)}
                            onClick={() => handleClick(link)}
                            sx={{ mb: 1, mt: 0, mx: 0, p: 0 }}
                        >
                            <Typography sx={{ color: 'primary.main', m: 0 }}>{link}</Typography>
                        </ArrowLink>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default InfoItem;
